import {IEntity} from './entity'
import { mapDateFromApi } from 'src/core/utils'
import { mapPaginationFromApi } from './paginated'
import { IDocument } from './document'

export enum PublicProductStatus {
    NON_DEMARRE = 'NON_DEMARRE',
    SOUSCRIPTION_OUVERTE = 'SOUSCRIPTION_OUVERTE',
    EN_COURS_DE_VIE = 'EN_COURS_DE_VIE',
    REMBOURSE_PAR_ANTICIPATION = 'REMBOURSE_PAR_ANTICIPATION',
    REMBOURSE_A_SON_TERME = 'REMBOURSE_A_SON_TERME',
}

export const PublicProductStatusArr = [
    'NON_DEMARRE',
    'SOUSCRIPTION_OUVERTE',
    'EN_COURS_DE_VIE',
    'REMBOURSE_PAR_ANTICIPATION',
    'REMBOURSE_A_SON_TERME',
]

export const PublicProductStatusMap = {
    NON_DEMARRE: 'non démarré',
    SOUSCRIPTION_OUVERTE: 'souscription ouverte',
    EN_COURS_DE_VIE: 'en cours de vie',
    REMBOURSE_PAR_ANTICIPATION: 'remboursé par anticipation',
    REMBOURSE_A_SON_TERME: 'remboursé à son terme',
}

export enum PublicProductProfile {
    PARTICIPATION = 'PARTICIPATION',
    RENDEMENT = 'RENDEMENT',
    CAPITAL_GARANTI = 'CAPITAL_GARANTI',
    CAPITAL_PROTEGE = 'CAPITAL_PROTEGE',
    AUTOCALL = 'AUTOCALL',
    CLN = 'CLN',
    PHOENIX = 'PHOENIX',
    PROTECTION = 'PROTECTION',
    REVERSE = 'REVERSE',
}

export const PublicProductProfileArr = [
    'PARTICIPATION',
    'RENDEMENT',
    'CAPITAL_GARANTI',
    'CAPITAL_PROTEGE',
    'AUTOCALL',
    'CLN',
    'PHOENIX',
    'PROTECTION',
    'REVERSE',
]

export const PublicProductProfileMap = {
    PARTICIPATION: 'Participation',
    RENDEMENT: 'Rendement',
    CAPITAL_GARANTI: 'Capital Garanti',
    CAPITAL_PROTEGE: 'Capital Protégé',
    AUTOCALL: 'Autocall',
    CLN: 'CLN',
    PHOENIX: 'Phoenix',
    PROTECTION: 'Protection',
    REVERSE: 'Reverse',
}

export interface IPublicProduct extends IEntity {
    created_at: Date;
    name: string;
    description?: string;
    code_isin?: string;
    image_cover_url?: string;
    status: PublicProductStatus;
    profile: PublicProductProfile;
    tag?: string;
    custom?: string;
    documents?: IDocument[]
}

export const mapPublicProductFromApi = (apiProduct: any): IPublicProduct => ({
    ...apiProduct,
    created_at: mapDateFromApi(apiProduct.created_at),
});
  
export const mapPublicProductPaginationFromApi = mapPaginationFromApi<IPublicProduct>(mapPublicProductFromApi)


// WEBPACK FOOTER //
// ./src/type/public-product.ts